module.exports = __webpack_public_path__ + "img/chegirma.709dcd67.png";